import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/navigation";

import React from "react";
import { Navigation, Pagination } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";

import { MostPlayedCard } from "@pages/casino/components";

import { CasinoMostPlayedSliderContainer, TitleContainer } from "./elements.js";
import useController from "./useController.js";

export const MostPlayedSlider = ({ data, type, isGamePage }) => {
	const {
		state: { slidesPerGroup, currentLanguage, windowWidth },
	} = useController();

	const topic = data?.topic[currentLanguage];

	if (!data?.isActive || !data?.gameList || !topic || data.gameList?.length === 0) {
		return null;
	}

	const { configs = {}, gameList = [] } = data;

	return (
		<CasinoMostPlayedSliderContainer isBackground={topic.includes("{user}")}>
			<TitleContainer>
				{data?.icon_url && <img src={data?.icon_url} />}
				<span>{topic}</span>
			</TitleContainer>
			<Swiper
				slidesPerView={"auto"}
				lazyPreloadPrevNext={1}
				spaceBetween={10}
				slidesPerGroup={slidesPerGroup}
				modules={[Pagination, Navigation]}
				breakpoints={{
					1600: {
						slidesOffsetBefore: 50,
						slidesOffsetAfter: 50,
					},
				}}
				navigation={{
					nextEl: ".swiper-button-next",
					prevEl: ".swiper-button-prev",
				}}>
				{gameList
					.slice()
					.sort((a, b) => b?.count - a?.count)
					.map((game, index) => {
						return (
							<SwiperSlide
								key={index}
								style={
									configs?.gameGrids?.length > 0
										? {
												width:
													configs?.gameGrids[index]?.bannerSize ===
														"1x2" ||
													configs?.gameGrids[index]?.bannerSize === "1x1"
														? windowWidth >= 1600
															? 350
															: 282
														: windowWidth >= 1600
															? 350
															: 282,
											}
										: { width: windowWidth >= 1600 ? 350 : 282 }
								}>
								<MostPlayedCard
									key={game?.id}
									type={type}
									game={game}
									size={data?.configs?.gameGrids?.[index]?.bannerSize || "1x1"}
									isGamePage={isGamePage}
								/>
							</SwiperSlide>
						);
					})}
				<div className="swiper-button-prev"></div>
				<div className="swiper-button-next"></div>
			</Swiper>
		</CasinoMostPlayedSliderContainer>
	);
};

export default MostPlayedSlider;
